import { initFirebase } from '../firebase'
import { collection, getDocs, getDoc, query, orderBy, doc, updateDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

const { db } = initFirebase()

const generatePlaybookImagesFn = httpsCallable(functions, 'generatePlaybookImages')

export class FirebasePlaybooksService {
  async getAllPlaybooks() {
    const ref = collection(db, 'playbooks')
    const q = query(ref, orderBy('createdAt', 'desc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async getSlides(playbookId) {
    if (!playbookId) return []
    const ref = collection(db, 'playbooks', playbookId, 'slides')
    const q = query(ref, orderBy('slideNumber', 'asc'))
    const snap = await getDocs(q)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  }

  async updatePlaybookStatus(playbookId, status) {
    const ref = doc(db, 'playbooks', playbookId)
    await updateDoc(ref, { status })
  }

  // Overlays live in an array inside the slide doc. Read-modify-write the whole array.
  async setOverlayStatus(playbookId, slideDocId, overlayId, status) {
    const slideRef = doc(db, 'playbooks', playbookId, 'slides', slideDocId)
    const snap = await getDoc(slideRef)
    if (!snap.exists()) throw new Error('Slide not found')
    const overlays = (snap.data().overlays || []).map(o =>
      o.id === overlayId ? { ...o, status } : o
    )
    await updateDoc(slideRef, { overlays })
    return overlays
  }

  // Bulk set every overlay in a slide to a status (approve all / reset all).
  async setAllOverlayStatus(playbookId, slideDocId, status) {
    const slideRef = doc(db, 'playbooks', playbookId, 'slides', slideDocId)
    const snap = await getDoc(slideRef)
    if (!snap.exists()) throw new Error('Slide not found')
    const overlays = (snap.data().overlays || []).map(o => ({ ...o, status }))
    await updateDoc(slideRef, { overlays })
    return overlays
  }

  // Generate N image variations for a slide via Higgsfield Nano Banana (backend holds the key).
  async generateSlideImages(playbookId, slideDocId, count, aspectRatio) {
    const result = await generatePlaybookImagesFn({ playbookId, slideDocId, count, aspectRatio })
    return result.data
  }

  // Images live in an array inside the slide doc. Read-modify-write the whole array.
  async setImageStatus(playbookId, slideDocId, imageId, status) {
    const slideRef = doc(db, 'playbooks', playbookId, 'slides', slideDocId)
    const snap = await getDoc(slideRef)
    if (!snap.exists()) throw new Error('Slide not found')
    const images = (snap.data().images || []).map(im =>
      im.id === imageId ? { ...im, status } : im
    )
    await updateDoc(slideRef, { images })
    return images
  }
}
